import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { translateServerSideProps } from 'shared/utils/translate-server-side-props'
import ResubscribedCard from 'modules/unsubscribe-page/components/resubscribed-card'
import UnsubscribeCard from 'modules/unsubscribe-page/components/unsubscribed-card'
import { useResubscribe } from 'modules/unsubscribe-page/hooks/use-resubscribe'
import { useUnsubscribe } from 'modules/unsubscribe-page/hooks/use-unsubscribe'
import { getUnsubscribePageLayout } from 'modules/unsubscribe-page/layouts/get-unsubscribe-page-layout'

function Unsubscribe() {
  const { t } = useTranslation()
  const { query } = useRouter()
  const path = query.path as string[]
  const slug = path[0] as string

  const [isSuccess, setIsSuccess] = useState(false)

  const { unsubscribeFromTransactionalEmail, isFetching: isFetchingUnsubscribe } = useUnsubscribe()
  const { resubscribeToTransactionalEmail, isFetching: isFetchingResubscribe } = useResubscribe()

  async function confirmResubscribed() {
    await resubscribeToTransactionalEmail(slug)
  }

  async function confirmUnsubscribe() {
    await unsubscribeFromTransactionalEmail(slug)
    setIsSuccess(true)
  }

  return (
    <div className="flex flex-col items-center justify-center">
      {isSuccess ? (
        <ResubscribedCard
          subTitle={t('mailing.unsubscribed_transactional_page.success.text')}
          title={t('mailing.unsubscribe.success_title')}
          isFetching={isFetchingResubscribe}
          onConfirmResubscribed={confirmResubscribed}
        />
      ) : (
        <UnsubscribeCard
          isSuccess={true}
          isFetching={isFetchingUnsubscribe}
          onConfirmUnsubscribe={confirmUnsubscribe}
          title={t('unsubscribe_page.unsubscribe.title')}
        >
          <div className={'mb-8'}>
            {t('mailing.unsubscribed_transactional_page.unsubscribed.text')}
          </div>
        </UnsubscribeCard>
      )}
    </div>
  )
}

export const getServerSideProps = translateServerSideProps

Unsubscribe.getLayout = getUnsubscribePageLayout

export default Unsubscribe
